export const RANDOM_ARTWORK = "RANDOM_ARTWORK";
export const RANDOM_ARTWORK_RESET = "RANDOM_ARTWORK_RESET";

export const randomArtwork = (params) => {
  return { type: RANDOM_ARTWORK, params };
};

export const randomArtworkReset = () => {
  return { type: RANDOM_ARTWORK_RESET };
};
